(function () {
  'use strict';

  var MAX_FILE_BYTES = 5 * 1024 * 1024;
  var ACCEPTED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'];

  function initCreatorHero(heroNote) {
    if (!heroNote || heroNote.dataset.cpHeroInitialized === 'true') return;
    heroNote.dataset.cpHeroInitialized = 'true';

    var hero = heroNote.closest('.cp-hero');
    if (!hero) return;

    var heroSlides = Array.prototype.slice.call(hero.querySelectorAll('[data-cp-hero-slide]'));
    var heroDots = Array.prototype.slice.call(hero.querySelectorAll('[data-cp-hero-dot]'));
    var heroIndex = 0;
    var heroTimer;

    function showHeroSlide(index) {
      if (!heroSlides.length) return;
      heroIndex = (Number(index) + heroSlides.length) % heroSlides.length;
      heroSlides.forEach(function (slide, slideIndex) {
        var isActive = slideIndex === heroIndex;
        slide.hidden = !isActive;
        slide.classList.toggle('is-active', isActive);
      });
      heroDots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === heroIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function stopHeroCarousel() {
      window.clearInterval(heroTimer);
    }

    function startHeroCarousel() {
      stopHeroCarousel();
      if (heroSlides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      heroTimer = window.setInterval(function () { showHeroSlide(heroIndex + 1); }, 5200);
    }

    heroDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        showHeroSlide(dot.getAttribute('data-cp-hero-dot'));
        startHeroCarousel();
      });
    });

    heroNote.addEventListener('mouseenter', stopHeroCarousel);
    heroNote.addEventListener('mouseleave', startHeroCarousel);
    heroNote.addEventListener('focusin', stopHeroCarousel);
    heroNote.addEventListener('focusout', startHeroCarousel);

    showHeroSlide(0);
    startHeroCarousel();
  }

  function initCreatorStoryVideo(video) {
    if (!video || video.dataset.cpStoryVideoInitialized === 'true') return;
    video.dataset.cpStoryVideoInitialized = 'true';
    video.muted = true;
    video.defaultMuted = true;

    var isInView = false;
    var retryTimer;
    var watchdogTimer;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function stopRetry() {
      window.clearTimeout(retryTimer);
    }

    function allowManualPlayback() {
      video.controls = true;
      video.classList.add('is-autoplay-blocked');
    }

    function syncInViewFromRect() {
      var rect = video.getBoundingClientRect();
      var viewportTop = rect.top;
      var viewportBottom = rect.bottom;
      if (viewportTop > window.innerHeight && window.scrollY > 0) {
        viewportTop -= window.scrollY;
        viewportBottom -= window.scrollY;
      }
      isInView = viewportBottom > 0 && viewportTop < window.innerHeight;
      video.dataset.cpStoryInView = String(isInView);
      return isInView;
    }

    function playVideo() {
      stopRetry();
      if (!isInView || document.hidden || reducedMotion.matches) return;

      var playRequest;
      try {
        playRequest = video.play();
      } catch (error) {
        allowManualPlayback();
        return;
      }

      if (playRequest && typeof playRequest.catch === 'function') {
        playRequest.catch(allowManualPlayback);
      }
    }

    function retryIfPaused() {
      stopRetry();
      if (!isInView || document.hidden || reducedMotion.matches || !video.paused) return;
      retryTimer = window.setTimeout(playVideo, 180);
    }

    function syncVisibility() {
      if (document.hidden) {
        stopRetry();
        video.pause();
      } else {
        playVideo();
      }
    }

    video.addEventListener('loadeddata', playVideo);
    video.addEventListener('canplay', playVideo);
    video.addEventListener('pause', retryIfPaused);
    video.addEventListener('playing', function () {
      video.classList.remove('is-autoplay-blocked');
      video.controls = false;
    });
    video.addEventListener('error', allowManualPlayback);
    document.addEventListener('visibilitychange', syncVisibility);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== video) return;
          isInView = entry.isIntersecting && entry.intersectionRatio >= 0.2;
          if (isInView) playVideo();
          else {
            stopRetry();
            video.pause();
          }
        });
      }, { threshold: [0, 0.2, 0.6] });
      observer.observe(video);
    } else {
      var syncFallbackViewport = function () {
        syncInViewFromRect();
        if (isInView) playVideo();
        else {
          stopRetry();
          video.pause();
        }
      };
      window.addEventListener('scroll', syncFallbackViewport, { passive: true });
      window.addEventListener('resize', syncFallbackViewport);
      syncFallbackViewport();
    }

    watchdogTimer = window.setInterval(function () {
      if (!video.isConnected) {
        window.clearInterval(watchdogTimer);
        return;
      }
      syncInViewFromRect();
      retryIfPaused();
    }, 1500);

    if (reducedMotion.matches) allowManualPlayback();
  }

  function initCreatorProgram(root) {
    if (!root || root.dataset.cpInitialized === 'true') return;
    root.dataset.cpInitialized = 'true';

    var form = root.querySelector('[data-cp-form]');
    if (!form) return;

    var steps = Array.prototype.slice.call(form.querySelectorAll('[data-cp-step]'));
    var progressButtons = Array.prototype.slice.call(root.querySelectorAll('[data-cp-progress]'));
    var pathInputs = Array.prototype.slice.call(form.querySelectorAll('input[name="application_path"]'));
    var successMessage = root.querySelector('[data-cp-success]');
    var errorMessage = root.querySelector('[data-cp-error]');
    var submitButton = form.querySelector('[data-cp-submit]');
    var startedAt = form.querySelector('[data-cp-started-at]');
    var userAgent = form.querySelector('[data-cp-user-agent]');
    var email = form.querySelector('[data-cp-email]');
    var emailConfirm = form.querySelector('[data-cp-email-confirm]');
    var currentStep = 1;
    var defaultSubmitLabel = submitButton ? submitButton.textContent : '';
    var slowNoticeTimer;

    if (startedAt) startedAt.value = String(Date.now());
    if (userAgent) userAgent.value = navigator.userAgent || '';

    function selectedPath() {
      var selected = pathInputs.find(function (input) { return input.checked; });
      return selected ? selected.value : '';
    }

    function setControlsDisabled(container, disabled) {
      if (!container) return;
      Array.prototype.slice.call(container.querySelectorAll('input, select, textarea, button')).forEach(function (control) {
        control.disabled = disabled;
      });
    }

    function syncPathVisibility() {
      var path = selectedPath();

      Array.prototype.slice.call(root.querySelectorAll('[data-cp-path-only]')).forEach(function (group) {
        var isActive = group.getAttribute('data-cp-path-only') === path;
        group.hidden = !isActive;
        setControlsDisabled(group, !isActive || Number(group.closest('[data-cp-step]').getAttribute('data-cp-step')) !== currentStep);
      });

      Array.prototype.slice.call(root.querySelectorAll('[data-cp-path-panel]')).forEach(function (panel) {
        var isActive = panel.getAttribute('data-cp-path-panel') === path;
        panel.hidden = !isActive;
        setControlsDisabled(panel, !isActive || currentStep !== 4);
      });
    }

    function setStep(stepNumber, shouldFocus) {
      currentStep = Math.max(1, Math.min(4, Number(stepNumber) || 1));

      steps.forEach(function (step) {
        var isActive = Number(step.getAttribute('data-cp-step')) === currentStep;
        step.hidden = !isActive;
        step.disabled = !isActive;
        step.classList.toggle('is-active', isActive);
      });

      progressButtons.forEach(function (button) {
        var index = Number(button.getAttribute('data-cp-progress'));
        button.classList.toggle('is-active', index === currentStep);
        button.classList.toggle('is-complete', index < currentStep);
        button.setAttribute('aria-current', index === currentStep ? 'step' : 'false');
      });

      syncPathVisibility();

      if (shouldFocus) {
        var activeStep = steps.find(function (step) { return Number(step.getAttribute('data-cp-step')) === currentStep; });
        var legend = activeStep && activeStep.querySelector('legend');
        if (legend) {
          legend.setAttribute('tabindex', '-1');
          legend.focus({ preventScroll: true });
        }
        if (root.scrollIntoView) root.querySelector('.creator-program__form-shell').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function clearMessages() {
      if (successMessage) successMessage.hidden = true;
      if (errorMessage) errorMessage.hidden = true;
    }

    function showMessage(target, message) {
      if (!target) return;
      target.textContent = message;
      target.hidden = false;
      if (target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function showError(message) {
      if (successMessage) successMessage.hidden = true;
      showMessage(errorMessage, message || '入力内容をご確認ください。');
    }

    function validateEmailMatch() {
      if (!email || !emailConfirm) return true;
      emailConfirm.setCustomValidity('');
      if (emailConfirm.value && email.value.trim().toLowerCase() !== emailConfirm.value.trim().toLowerCase()) {
        emailConfirm.setCustomValidity('メールアドレスが一致しません。');
        return false;
      }
      return true;
    }

    function validateCheckboxGroup(name, container, message) {
      var checked = container && container.querySelector('input[name="' + name + '"]:checked');
      if (checked) return true;
      showError(message);
      var first = container && container.querySelector('input[name="' + name + '"]');
      if (first) first.focus();
      return false;
    }

    function validateCurrentStep() {
      clearMessages();
      var activeStep = steps.find(function (step) { return Number(step.getAttribute('data-cp-step')) === currentStep; });
      if (!activeStep) return false;

      validateEmailMatch();

      if (!activeStep.checkValidity()) {
        activeStep.reportValidity();
        return false;
      }

      var path = selectedPath();
      if (currentStep === 1 && !path) {
        showError('参加方法を選択してください。');
        return false;
      }

      if (currentStep === 3 && path === '無料サンプルに応募') {
        var followers = Number(form.elements.followers && form.elements.followers.value);
        var visibility = form.querySelector('input[name="account_visibility"]:checked');
        if (followers < 1000) {
          showError('無料サンプル応募には、単一プラットフォームで1,000以上のフォロワー・登録者が必要です。');
          form.elements.followers.focus();
          return false;
        }
        if (!visibility || visibility.value !== '公開') {
          showError('無料サンプル応募には公開アカウントが必要です。');
          return false;
        }
      }

      if (currentStep === 4 && path === '製品を持っている') {
        var ownerPanel = root.querySelector('[data-cp-path-panel="製品を持っている"]');
        if (!validateCheckboxGroup('owner_promo_channels', ownerPanel, '予定している紹介チャネルを1つ以上選択してください。')) return false;
      }

      if (currentStep === 4 && path === '無料サンプルに応募') {
        var samplePanel = root.querySelector('[data-cp-path-panel="無料サンプルに応募"]');
        if (!validateCheckboxGroup('expected_format', samplePanel, '想定しているコンテンツ形式を1つ以上選択してください。')) return false;
      }

      return true;
    }

    function localizedValidity(field) {
      if (!field || !field.validity) return '';
      if (field === emailConfirm && !validateEmailMatch()) return 'メールアドレスが一致しません。';
      if (field.validity.valueMissing) {
        if (field.type === 'checkbox' || field.type === 'radio') return 'この項目を確認してください。';
        if (field.type === 'file') return 'ファイルを選択してください。';
        if (field.tagName === 'SELECT') return 'この項目を選択してください。';
        return 'この項目を入力してください。';
      }
      if (field.validity.typeMismatch && field.type === 'email') return 'メールアドレスを正しく入力してください。';
      if (field.validity.typeMismatch && field.type === 'url') return 'URLを https:// から正しく入力してください。';
      if (field.validity.rangeUnderflow || field.validity.rangeOverflow || field.validity.badInput) return '入力値を確認してください。';
      return '';
    }

    Array.prototype.slice.call(form.querySelectorAll('input, select, textarea')).forEach(function (field) {
      field.addEventListener('invalid', function () {
        field.setCustomValidity('');
        field.setCustomValidity(localizedValidity(field));
      });
      field.addEventListener('input', function () {
        field.setCustomValidity('');
        if (field === email || field === emailConfirm) validateEmailMatch();
      });
      field.addEventListener('change', function () {
        field.setCustomValidity('');
        if (field === email || field === emailConfirm) validateEmailMatch();
      });
    });

    pathInputs.forEach(function (input) {
      input.addEventListener('change', syncPathVisibility);
    });

    root.creatorProgramChoosePath = function (value) {
      var target = pathInputs.find(function (input) { return input.value === value; });
      if (target) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
      setStep(1, false);
      root.querySelector('.creator-program__form-shell').scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    progressButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var targetStep = Number(button.getAttribute('data-cp-progress'));
        if (targetStep < currentStep) setStep(targetStep, true);
      });
    });

    Array.prototype.slice.call(form.querySelectorAll('[data-cp-next]')).forEach(function (button) {
      button.addEventListener('click', function () {
        if (!validateCurrentStep()) return;
        setStep(currentStep + 1, true);
      });
    });

    Array.prototype.slice.call(form.querySelectorAll('[data-cp-prev]')).forEach(function (button) {
      button.addEventListener('click', function () {
        clearMessages();
        setStep(currentStep - 1, true);
      });
    });

    Array.prototype.slice.call(form.querySelectorAll('[data-cp-file]')).forEach(function (input) {
      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        var display = input.closest('.creator-program__upload').querySelector('[data-cp-file-name]');
        input.setCustomValidity('');
        if (!file) return;
        if (file.size > MAX_FILE_BYTES) input.setCustomValidity('ファイルは5MB以内にしてください。');
        if (ACCEPTED_FILE_TYPES.indexOf(String(file.type).toLowerCase()) === -1) input.setCustomValidity('JPG、PNG、WEBP、PDF形式を選択してください。');
        if (display) display.textContent = file.name + '（' + Math.max(1, Math.round(file.size / 1024)) + 'KB）';
      });
    });

    Array.prototype.slice.call(form.querySelectorAll('[data-cp-counted]')).forEach(function (textarea) {
      var count = textarea.parentElement.querySelector('[data-cp-count]');
      textarea.addEventListener('input', function () {
        if (count) count.textContent = String(textarea.value.length);
      });
    });

    function appendPayloadValue(payload, name, value) {
      if (Object.prototype.hasOwnProperty.call(payload, name)) {
        if (!Array.isArray(payload[name])) payload[name] = [payload[name]];
        payload[name].push(value);
      } else {
        payload[name] = value;
      }
    }

    function buildFieldPayload() {
      var payload = {};
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (!field.name || field.disabled) return;
        if (field.type === 'file' || field.type === 'submit' || field.type === 'button') return;
        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
        appendPayloadValue(payload, field.name, field.value);
      });
      return payload;
    }

    function fileToBase64WebSafe(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          var result = String(reader.result || '');
          var commaIndex = result.indexOf(',');
          var base64 = commaIndex >= 0 ? result.slice(commaIndex + 1) : result;
          resolve(base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, ''));
        };
        reader.onerror = function () { reject(new Error('添付ファイルを読み込めませんでした。')); };
        reader.readAsDataURL(file);
      });
    }

    function createApplicationId() {
      var now = new Date();
      var stamp = [
        now.getFullYear(),
        String(now.getMonth() + 1).padStart(2, '0'),
        String(now.getDate()).padStart(2, '0'),
        String(now.getHours()).padStart(2, '0'),
        String(now.getMinutes()).padStart(2, '0'),
        String(now.getSeconds()).padStart(2, '0')
      ].join('');
      var random = Math.floor(Math.random() * 1000000).toString().padStart(6, '0');
      return 'CP-' + stamp + '-' + random;
    }

    function buildAppsScriptPayload() {
      var activeFiles = Array.prototype.slice.call(form.querySelectorAll('input[type="file"]')).filter(function (input) {
        return !input.disabled && input.files && input.files[0];
      });
      return Promise.all(activeFiles.map(function (input) {
        var file = input.files[0];
        if (file.size > MAX_FILE_BYTES) throw new Error('添付ファイルは1件につき5MB以内にしてください。');
        if (ACCEPTED_FILE_TYPES.indexOf(String(file.type).toLowerCase()) === -1) throw new Error('添付できる形式はJPG、PNG、WEBP、PDFです。');
        return fileToBase64WebSafe(file).then(function (data) {
          return {
            fieldName: input.name,
            name: file.name,
            type: file.type,
            size: file.size,
            data: data
          };
        });
      })).then(function (files) {
        return { applicationId: createApplicationId(), fields: buildFieldPayload(), files: files };
      });
    }

    function isTrustedAppsScriptOrigin(origin) {
      try {
        var hostname = new URL(origin).hostname;
        return hostname === 'script.google.com' || hostname === 'script.googleusercontent.com' || hostname.slice(-22) === '.googleusercontent.com';
      } catch (error) {
        return false;
      }
    }

    function submitWithAppsScript(payload) {
      return new Promise(function (resolve, reject) {
        var frameName = form.id + '-receiver-frame';
        var iframe = document.createElement('iframe');
        var transportForm = document.createElement('form');
        var payloadField = document.createElement('textarea');
        var callbackName = 'creatorProgramStatus_' + payload.applicationId.replace(/[^0-9A-Za-z_]/g, '_');
        var timeoutId;
        var pollTimer;
        var pollDelay = 7000;
        var completed = false;

        function cleanup() {
          window.clearTimeout(timeoutId);
          window.clearTimeout(pollTimer);
          window.removeEventListener('message', handleMessage);
          try { delete window[callbackName]; } catch (error) { window[callbackName] = undefined; }
          if (transportForm.parentNode) transportForm.parentNode.removeChild(transportForm);
          window.setTimeout(function () { if (iframe.parentNode) iframe.parentNode.removeChild(iframe); }, 1000);
        }

        function finishSuccess(data) {
          if (completed) return;
          completed = true;
          cleanup();
          resolve(data || { ok: true, message: 'ご応募を受け付けました。' });
        }

        function finishError(error) {
          if (completed) return;
          completed = true;
          cleanup();
          reject(error);
        }

        function schedulePoll() {
          pollTimer = window.setTimeout(pollStatus, pollDelay);
          pollDelay = Math.min(Math.round(pollDelay * 1.5), 20000);
        }

        function pollStatus() {
          var script = document.createElement('script');
          var separator = form.action.indexOf('?') === -1 ? '?' : '&';
          window[callbackName] = function (data) {
            if (data && data.ok && data.found) return finishSuccess(data);
            if (data && data.ok === false) return finishError(new Error(data.message || '送信に失敗しました。'));
            schedulePoll();
          };
          script.async = true;
          script.src = form.action + separator + 'action=status&application_id=' + encodeURIComponent(payload.applicationId) + '&callback=' + encodeURIComponent(callbackName) + '&_=' + Date.now();
          script.onload = script.onerror = function () {
            window.setTimeout(function () { if (script.parentNode) script.parentNode.removeChild(script); }, 0);
          };
          document.head.appendChild(script);
        }

        function handleMessage(event) {
          if (!isTrustedAppsScriptOrigin(event.origin)) return;
          var data = event.data;
          if (typeof data === 'string') {
            try { data = JSON.parse(data); } catch (error) { return; }
          }
          if (!data || data.source !== 'creator-program-receiver') return;
          if (data.ok) finishSuccess(data);
          else finishError(new Error(data.message || '送信に失敗しました。'));
        }

        iframe.name = frameName;
        iframe.hidden = true;
        iframe.style.display = 'none';
        transportForm.method = 'post';
        transportForm.action = form.action;
        transportForm.target = frameName;
        transportForm.style.display = 'none';
        payloadField.name = 'payload';
        payloadField.value = JSON.stringify(payload);
        transportForm.appendChild(payloadField);

        window.addEventListener('message', handleMessage);
        timeoutId = window.setTimeout(function () {
          finishError(new Error('送信結果を確認できませんでした。重複送信を避けるため、すぐに再送せず、受付メールをご確認ください。'));
        }, 300000);
        schedulePoll();
        document.body.appendChild(iframe);
        document.body.appendChild(transportForm);
        transportForm.submit();
      });
    }

    function setSubmitting(isSubmitting) {
      window.clearTimeout(slowNoticeTimer);
      form.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
      if (submitButton) {
        submitButton.disabled = isSubmitting || root.dataset.formReady !== 'true';
        submitButton.textContent = isSubmitting ? '送信中です…' : defaultSubmitLabel;
      }
      if (isSubmitting) {
        slowNoticeTimer = window.setTimeout(function () {
          showMessage(successMessage, '添付ファイルと応募内容を送信しています。この画面を閉じずにお待ちください。');
        }, 12000);
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearMessages();

      if (root.dataset.formReady !== 'true' || !form.action) {
        showError('現在はテスト準備中です。送信先の設定後に応募できるようになります。');
        return;
      }

      if (!validateCurrentStep()) return;
      setSubmitting(true);

      buildAppsScriptPayload()
        .then(submitWithAppsScript)
        .then(function (result) {
          form.reset();
          if (startedAt) startedAt.value = String(Date.now());
          if (userAgent) userAgent.value = navigator.userAgent || '';
          Array.prototype.slice.call(form.querySelectorAll('[data-cp-file-name]')).forEach(function (node) {
            node.textContent = node.closest('[data-cp-path-panel]') ? '画像またはPDF／5MB以内' : '直近30日または90日の分析画面／5MB以内';
          });
          setStep(1, false);
          showMessage(successMessage, result && result.message ? result.message : 'ご応募を受け付けました。');
        })
        .catch(function (error) {
          showError(error && error.message ? error.message : '送信できませんでした。時間をおいてもう一度お試しください。');
        })
        .finally(function () {
          setSubmitting(false);
        });
    });

    setStep(1, false);
  }

  function initGlobalPathButtons() {
    var pageRoot = document.documentElement;
    if (!pageRoot || pageRoot.dataset.cpPathButtonsInitialized === 'true') return;
    pageRoot.dataset.cpPathButtonsInitialized = 'true';

    document.addEventListener('click', function (event) {
      var button = event.target && event.target.closest && event.target.closest('[data-cp-choose-path]');
      if (!button) return;
      var formRoot = document.querySelector('[data-creator-program]');
      if (!formRoot || typeof formRoot.creatorProgramChoosePath !== 'function') return;
      formRoot.creatorProgramChoosePath(button.getAttribute('data-cp-choose-path'));
    });
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-cp-hero-note]')).forEach(initCreatorHero);
    Array.prototype.slice.call(document.querySelectorAll('[data-cp-story-video]')).forEach(initCreatorStoryVideo);
    Array.prototype.slice.call(document.querySelectorAll('[data-creator-program]')).forEach(initCreatorProgram);
    initGlobalPathButtons();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
})();
